import { Breadcrumb, Button, Card, Empty, Table } from "antd";
import React from "react";
import { useNavigate } from "react-router";
import { useState } from "react";
import { useCallback } from "react";
import { useEffect } from "react";
import AuthService from "../../services/auth.service";
import { ReactComponent as TitleIcon } from "../../assests/images/exchangeBreads.svg";
import {
  amountExchangeCurrencyFormat,
  amountNoCurrencyFormat,
} from "../../services/common.service";
import { useTranslation } from "react-i18next";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";
import PaginationComponent from "../../components/paginationComponet";

export default function ExchangeRateComponent() {
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState([]);
  const [noRecords, setNoRecords] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    getallExchangeRates();
  }, []);

  const getallExchangeRates = useCallback(async () => {
    try {
      const response = await AuthService.getallExchangeRates();
      if (response.status === 200) {
        setDataSource(response.data["crossCurRateList"]);
        setNoRecords(
          response.data["crossCurRateList"].length > 0 ? false : true
        );
      }
    } catch (error) {
      setNoRecords(true);
    }
  }, []);

  const [data, setData] = useState([]);

  useEffect(() => {
    setData(dataSource.slice(0, 10));
  }, [dataSource]);

  const handlePageChange = (currentPage, slicedData) => {
    setData(slicedData);
  };
  return (
    <>
      {" "}
        {/* <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {" "}
              {t("navigation.exchange_rate", {
                defaultValue: "Exchange Rates",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb> */}
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("navigation.exchange_rate", {
                defaultValue: "Exchange Rates",
              })}
            </h3>
          </div>
        </div>
      </Card>
   
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-7 col-xl-7">
          <Table
            size=""
            className="exchange-rates-table"
            dataSource={dataSource}
            rowClassName={(record, index) =>
              index % 2 === 0 ? "table-row-light" : "table-row-dark"
            }
            tableLayout="fixed"
            pagination={false}
            scroll={{ x: "100%" }}
            bordered
            sticky={true}
            columns={[
              {
                title: "Conversion Type",

                key: "symbol",
                render: (option) => (
                  <span className="d-flex align-items-center">
                  <img src={option?.flag} width={25} alt="flag" className="me-2"/>
                  <span>{option?.symbol}</span>
                  </span>
                ),
              },
              {
                title: t("pages.landing.buy_price", {
                  defaultValue: "Bank's Buy Rate",
                }),
                key: "buyRate",
                width: "30%",
                align: "right",
                render: (option) => (
                  <span>
                    {" "}
                    {amountExchangeCurrencyFormat(option?.buyRate) || "-"}
                  </span>
                ),
              },
              {
                title:  t("pages.landing.sell_price", {
                  defaultValue: "Bank's Sell Rate",
                }),
                width: "30%",
                key: "amount",
                align: "right",
                render: (option) => (
                  <span>
                    {" "}
                    {amountExchangeCurrencyFormat(option?.sellRate) || "-"}
                  </span>
                ),
              },
            ]}
          />

          <div className="btn-group mt-3 mb-3" align="end">
            <Button
              type="primary"
              onClick={() => getallExchangeRates()}
              size="large"
            >
              Refresh
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
